<app-header></app-header>
<app-set-meta title="パスワード再設定｜Forbes CAREER"></app-set-meta>
<div class="wrapper">
  <div class="pc_contents_wrapper">
    <h1>パスワード再設定</h1>
    <div class="form_wrapper">
      <form [formGroup]="form" *ngIf="!submitted">
        <div class="form-group">
          <input placeholder="メールアドレス" formControlName="email" class="form-control" />
        </div>
        <div *ngIf="submitError">
          入力したメールアドレスを確認してください
        </div>
        <button type="button" (click)="sendResetMail()" class="btn btn-primary btn-block">パスワード再設定</button>
      </form>

      <div *ngIf="submitted">
        パスワード再設定用のメールを送信しました
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
